import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEnglish from '@angular/common/locales/en';
import localeItalian from '@angular/common/locales/it';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  private _locale: string;

  constructor(
    @Inject(LOCALE_ID) public myLocale: string
  ) { }

  set locale(value: string) {
      this._locale = value;
  }
  get locale(): string {
      return this._locale || 'it';
  }

  registerCulture(culture: string) {
      if (!culture) {
          return;
      }
      this.locale = culture;

      switch (culture) {
          case 'en': {
              registerLocaleData(localeEnglish);
              break;
          }
          case 'it': {
              registerLocaleData(localeItalian);
              break;
          }
      }
  }

}
